import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Team, TeamApiResponse } from '../models/team.model';

@Injectable({
  providedIn: 'root',
})
export class TeamService {
  private apiUrl = `${environment.glassApiUrl}/v2/teams`;

  constructor(private http: HttpClient) {}

  getTeams(): Observable<TeamApiResponse> {
    return this.http.get<TeamApiResponse>(this.apiUrl);
  }

  getTeamById(id: string): Observable<TeamApiResponse> {
    return this.http.get<TeamApiResponse>(`${this.apiUrl}/${id}`);
  }

  createTeam(team: Partial<Team>): Observable<TeamApiResponse> {
    return this.http.post<TeamApiResponse>(this.apiUrl, team);
  }

  updateTeam(id: string, team: Partial<Team>): Observable<TeamApiResponse> {
    return this.http.put<TeamApiResponse>(`${this.apiUrl}/${id}`, team);
  }

  deleteTeam(id: string): Observable<TeamApiResponse> {
    return this.http.delete<TeamApiResponse>(`${this.apiUrl}/${id}`);
  }
}
